import Vue from 'vue';
import { formatDateTime } from './utils/format.js';

Vue.filter('dateTime', function(value, format) {
    return !value ? '' : formatDateTime(value, format);
});
